import { Option } from '../../../../general-types';

export const addAllOption = <TValue extends number | string, TLabel extends string>(
  options: Option<TValue, TLabel>[],
  isAddToEmptyArray?: boolean,
): Option<TValue | '', TLabel | 'All'>[] => {
  if (options.length || isAddToEmptyArray) {
    const allOption = { value: '', label: 'All' } as const;
    return [allOption, ...options];
  }
  return [];
};
